var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { createRef } from 'react';
import { ApprovedGateView } from './ApprovedGateView/ApprovedGateView';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { withRouter } from 'react-router-dom';
import { GateTabsWrapper } from '@app/Components/GateTabsWrapper/GateTabsWrapper';
var GatePreparationsC = /** @class */ (function (_super) {
    __extends(GatePreparationsC, _super);
    function GatePreparationsC() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._wrapper = createRef();
        return _this;
    }
    GatePreparationsC.prototype.onChangeGate = function (gate) {
        this._currentGate = gate;
    };
    GatePreparationsC.prototype.render = function () {
        var _a = this.props, projectId = _a.projectId, match = _a.match, location = _a.location, projectState = _a.projectState, projectType = _a.projectType, projectCodeName = _a.projectCodeName, projectHasOnlyMasterCheckLists = _a.projectHasOnlyMasterCheckLists;
        return (React.createElement(React.Fragment, null,
            React.createElement(GateTabsWrapper, { ref: this._wrapper, projectState: projectState, projectType: projectType, projectId: projectId, match: match, location: location, onChangeCurrentGateHandler: this.onChangeGate }, this._currentGate ? (React.createElement(ApprovedGateView, { projectId: projectId, gateId: this._currentGate.id, projectCodeName: projectCodeName, projectHasOnlyMasterCheckLists: projectHasOnlyMasterCheckLists })) : null)));
    };
    __decorate([
        observable
    ], GatePreparationsC.prototype, "_currentGate", void 0);
    __decorate([
        observable
    ], GatePreparationsC.prototype, "_wrapper", void 0);
    __decorate([
        action.bound
    ], GatePreparationsC.prototype, "onChangeGate", null);
    GatePreparationsC = __decorate([
        observer
    ], GatePreparationsC);
    return GatePreparationsC;
}(React.PureComponent));
export var GatePreparations = withRouter(GatePreparationsC);
